export default __webpack_public_path__ + "static/media/Mexican.ab035aa9.png";